module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-200.32a79f56.svg";